/**
 * Helpers compartidos para métodos de pago (caja, gastos, cierre, reportes).
 */

export function attachPaymentMethodHelpers(win) {
	win.posknMetodoEsBs = function posknMetodoEsBs(metodo) {
		const m = String(metodo || '').toLowerCase();
		if (!m) return false;
		if (win.posMetodosPagoMoneda && Object.prototype.hasOwnProperty.call(win.posMetodosPagoMoneda, metodo)) {
			return String(win.posMetodosPagoMoneda[metodo]).toUpperCase() === 'BS';
		}
		const map = win.POSKN_METODO_MONEDA || {};
		if (Object.prototype.hasOwnProperty.call(map, m)) {
			return String(map[m]).toUpperCase() === 'BS';
		}
		return m.indexOf('-bs') !== -1 || m.indexOf('_bs') !== -1;
	};

	win.formatearNombreMetodo = function formatearNombreMetodo(metodo) {
		if (win.posMetodosPagoNombres && win.posMetodosPagoNombres[metodo]) {
			return win.posMetodosPagoNombres[metodo];
		}
		const nombres = {
			'efectivo-usd': 'Efectivo USD',
			'efectivo-bs': 'Efectivo Bs',
			'tarjeta-usd': 'Tarjeta USD',
			'tarjeta-bs': 'Tarjeta Bs',
			'transferencia-usd': 'Transferencia USD',
			'transferencia-bs': 'Transferencia Bs',
			'pago-movil': 'Pago Móvil',
			'punto-venta': 'Punto de Venta',
			transferencia: 'Transferencia',
			credito: 'CREDITO',
			'pago-credito': 'CREDITO',
			otros: 'Otros',
		};
		return (
			nombres[metodo] ||
			String(metodo || '')
				.replace(/-/g, ' ')
				.replace(/\b\w/g, (l) => l.toUpperCase())
		);
	};

	win.obtenerSimboloMoneda = function obtenerSimboloMoneda(metodo) {
		return win.posknMetodoEsBs(metodo) ? 'Bs. ' : '$';
	};

	win.obtenerIconoMetodo = function obtenerIconoMetodo(metodo) {
		const iconos = {
			'efectivo-usd': '💵',
			'efectivo-bs': '💰',
			'tarjeta-usd': '💳',
			'tarjeta-bs': '💳',
			'transferencia-usd': '🏦',
			'transferencia-bs': '🏦',
			'pago-movil': '📱',
			'punto-venta': '💳',
			transferencia: '🏦',
			credito: '📝',
			'pago-credito': '📝',
			otros: '💼',
		};
		return iconos[metodo] || '💳';
	};
}
